export default __webpack_public_path__ + "static/media/range.f2652ef8.svg";